/**
 * The QR order "ding": two short sine tones (A5 then E6) from the Web Audio API,
 * so there is no audio file to load. Plays when an Accept prompt appears.
 * Browsers block audio until the page has been tapped; then it fails silently.
 */

/** Two prompts closer than this ding once (a realtime event and a list refresh). */
export const QR_DING_DEBOUNCE_MS = 1500;

let lastDingAt = 0;

export function playQrDing(now: number = Date.now()): boolean {
  if (now - lastDingAt < QR_DING_DEBOUNCE_MS) return false;
  lastDingAt = now;
  try {
    const Ctx =
      window.AudioContext ||
      (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
    if (!Ctx) return false;
    const ctx = new Ctx();
    const playTone = (freq: number, startTime: number, duration: number) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = "sine";
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0, ctx.currentTime + startTime);
      gain.gain.linearRampToValueAtTime(0.25, ctx.currentTime + startTime + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + startTime + duration);
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.start(ctx.currentTime + startTime);
      osc.stop(ctx.currentTime + startTime + duration);
    };
    playTone(880, 0, 0.18); // A5
    playTone(1320, 0.18, 0.22); // E6
    // Free the audio context once the tones are done.
    setTimeout(() => {
      void ctx.close().catch(() => undefined);
    }, 600);
    return true;
  } catch {
    // No Web Audio, or the autoplay policy said no.
    return false;
  }
}

/** Test hook: forget the debounce. */
export function resetQrDingForTests(): void {
  lastDingAt = 0;
}
